import React from 'react';

import ElementConstants from '../../../../shared/constants/elements';

import TextFieldElement from '../../../components/form-elements/inputs/text-field';
import TextareaElement from '../../../components/form-elements/inputs/textarea';
import NumberFieldElement from '../../../components/form-elements/inputs/number-field';
import LinkFieldElement from '../../../components/form-elements/inputs/link-field';
import DateFieldElement from '../../../components/form-elements/inputs/date-field';
import TimeFieldElement from '../../../components/form-elements/inputs/time-field';
import FileUploadElement from '../../../components/form-elements/inputs/file-upload';
import EmailFieldElement from '../../../components/form-elements/inputs/email-field';
import RadioButtonElement from '../../../components/form-elements/inputs/radio-button';
import MultiChoicePayOption from '../../../components/form-elements/inputs/multi-choice-pay-option';
import CheckboxElement from '../../../components/form-elements/inputs/checkbox';
import AddressElement from '../../../components/form-elements/inputs/address';
import ContactElement from '../../../components/form-elements/inputs/contact';
import PhoneNumberElement from '../../../components/form-elements/inputs/phone';
import SignatureFieldElement from "../../../components/form-elements/inputs/signature";

const InputElements = {
	CONTACT:{
		type: ElementConstants.INPUTS.CONTACT,
		component: <ContactElement />
	},
	ADDRESS:{
		type: ElementConstants.INPUTS.ADDRESS,
		component: <AddressElement />
	},
	TEXT: {
		type: ElementConstants.INPUTS.TEXT,
		component: <TextFieldElement />
	},
	TEXTAREA: {
		type: ElementConstants.INPUTS.TEXTAREA,
		component: <TextareaElement />
	},
	NUMBER: {
		type: ElementConstants.INPUTS.NUMBER,
		component: <NumberFieldElement />
	},
	LINK: {
		type: ElementConstants.INPUTS.LINK,
		component: <LinkFieldElement />
	},
	EMAIL: {
		type: ElementConstants.INPUTS.EMAIL,
		component: <EmailFieldElement />
	},
	PHONE: {
		type: ElementConstants.INPUTS.PHONE,
		component: <PhoneNumberElement />
	},
	DATE: {
		type: ElementConstants.INPUTS.DATE,
		component: <DateFieldElement />
	},
	TIME: {
		type: ElementConstants.INPUTS.TIME,
		component: <TimeFieldElement />
	},
	FILE_UPLOAD: {
		type: ElementConstants.INPUTS.FILE_UPLOAD,
		component: <FileUploadElement />
	},
	RADIO_BUTTON: {
		type: ElementConstants.INPUTS.RADIO_BUTTON,
		component: <RadioButtonElement />
	},
	MULTI_CHOICE_PAY_OPTION: {
		type: ElementConstants.INPUTS.MULTI_CHOICE_PAY_OPTION,
		component: <MultiChoicePayOption />
	},
	CHECKBOX: {
		type: ElementConstants.INPUTS.CHECKBOX,
		component: <CheckboxElement />
	},
	USER_SIGNATURE: {
		type: ElementConstants.INPUTS.USER_SIGNATURE,
		component: <SignatureFieldElement />
	}
}

export default InputElements;



// WEBPACK FOOTER //
// ./src/main/webapps/features/form-builder/react/editor/constants/elements/editor/inputs.js